import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Box, CssBaseline, ThemeProvider, Typography, createTheme } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FeedbackFormPublic from './FeedbackFormPublic';

const publicTheme = createTheme({
  palette: {
    primary: { main: '#7B08EF' },
  },
  typography: {
    fontFamily: '"Poppins", "Segoe UI", sans-serif',
  },
});

export default function PublicApp() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={publicTheme}>
        <CssBaseline />
        <Routes>
          <Route path="/f/:slug" element={<FeedbackFormPublic />} />
          <Route
            path="*"
            element={
              <Box minHeight="100vh" display="flex" alignItems="center" justifyContent="center" p={3}>
                <Typography>Form not found</Typography>
              </Box>
            }
          />
        </Routes>
        <ToastContainer position="bottom-right" autoClose={4000} />
      </ThemeProvider>
    </BrowserRouter>
  );
}
